export default "__VITE_ASSET__e94276e9__"